export const ADD_USER_STATE = "ADD_USER_STATE";
export const SET_USER_LOGIN = "SET_USER_LOGIN";
export const UNSET_USER = "UNSET_USER";
export const GET_WORKER_APPOINTMENTS = "GET_WORKER_APPOINTMENTS";
export const SET_ACTIVE_APPOINTMENT = "SET_ACTIVE_APPOINTMENT";
